/* eslint-disable max-lines-per-function */
import React, { useEffect, useState } from 'react';
import { ErrorMessage, Field, useFormikContext, Form as FormFormik } from 'formik';
import { Button } from 'primereact/button';
import { Fieldset } from 'primereact/fieldset';
import { InputMask } from 'primereact/inputmask';
import { InputText } from 'primereact/inputtext';
import { Message } from 'primereact/message';
import { RadioButton } from 'primereact/radiobutton';
import AceiteEletronicoEnvio from './AceiteEletronicoIEnvio';

export default function AceiteEletronicoForm({ sucesso, tipoCob, close, checarCelular, celularInvalido, adesaoPaga }) {
    const [submitButtonDisabled, setSubmitButtonDisabled] = useState(false);

    const { errors, handleSubmit, values, setFieldValue } = useFormikContext();

    useEffect(() => {
        const celularFormatado = values.TelefoneEnvio.replace(/ |-|\(|\)/gi, '');

        if (Number(celularFormatado) && `${Number(celularFormatado)}`.length === 11 && !celularInvalido) {
            checarCelular(celularFormatado, errors);
        }
    }, [values.TelefoneEnvio]);

    useEffect(() => {
        const errorsKeys = Object.keys(errors);

        if ((values.FormaEnvio === 1 || values.FormaEnvio === 3) && errorsKeys && errorsKeys.includes('TelefoneEnvio')) {
            setSubmitButtonDisabled(true);

            return;
        } else if (values.FormaEnvio === 2 && errorsKeys && errorsKeys.includes('EmailEnvio')) {
            setSubmitButtonDisabled(true);

            return;
        }

        setSubmitButtonDisabled(false);
    }, [errors]);

    function handleChangeTipoAceite(value) {
        value && setFieldValue('TipoAceite', value);
    }

    return <FormFormik className="p-col-12 p-md-12 p-lg-12 p-sm-12">
        <div className=" p-col-6 p-md-6">
            {sucesso && (
                <Message
                    severity="success"
                    text="Aceite enviado"
                />
            )}

        </div>

        <Fieldset className='envioDeAceite' legend="Envio">
            <div className="p-field p-grid">
                <h2
                    className="p-col-12 p-md-12 p-lg-12 p-sm-12"
                    style={{
                        marginLeft: '5px'
                    }}
                >
                    Tipo de Envio
                </h2>

                <AceiteEletronicoEnvio envio={values.TipoAceite} setEnvio={handleChangeTipoAceite} tipoCob={tipoCob} adesaoPaga={adesaoPaga} />

                <h2 className="p-col-12 p-md-12 p-lg-12 p-sm-12" style={{
                    marginBottom: '5px',
                    marginTop: '15px'
                }}>
                    Forma de Envio
                </h2>
                <div className="p-field-checkbox p-col-12 p-md-4 p-lg-3 p-sm-3">
                    <Field
                        as={RadioButton}
                        inputId="tipoEmail"
                        name="tipoEmail"
                        value={2}
                        onChange={e =>
                            setFieldValue('FormaEnvio', e.value)
                        }
                        checked={values.FormaEnvio === 2}
                    />
                    <label htmlFor="tipoEmail">
                        Email
                    </label>
                </div>
                <div className="p-field-checkbox p-col-12 p-md-4 p-lg-4 p-sm-4">
                    <Field
                        as={RadioButton}
                        inputId="tipoWhats"
                        name="tipoWhats"
                        value={3}
                        onChange={e =>
                            setFieldValue('FormaEnvio', e.value)
                        }
                        checked={values.FormaEnvio === 3}
                    />
                    <label htmlFor="tipoWhats">
                        Whatsapp
                    </label>
                </div>
                <div className="p-field-checkbox p-col-12 p-md-4 p-lg-5 p-sm-5">
                    <Field
                        as={RadioButton}
                        inputId="tipoMsg"
                        name="tipoMsg"
                        value={1}
                        onChange={e =>
                            setFieldValue('FormaEnvio', e.value)
                        }
                        checked={values.FormaEnvio === 1}
                    />
                    <label htmlFor="tipoMsg">
                        Mensagem de texto
                    </label>
                </div>
            </div>
            <br />
            <div className="p-grid p-fluid ">
                {values.FormaEnvio === 2 && <div className="p-col-12 p-md-8">
                    <Field
                        as={InputText}
                        name="EmailEnvio"
                        id="EmailEnvio"
                        placeholder="Email"
                    />
                    <ErrorMessage
                        component="span"
                        name="EmailEnvio"
                        style={{
                            color: 'red'
                        }}
                    />
                </div>}
                {(values.FormaEnvio === 1 || values.FormaEnvio === 3) && <div className="p-col-12 p-md-8">
                    <Field
                        type="text"
                        value={values.TelefoneEnvio}
                        as={InputMask}
                        name="TelefoneEnvio"
                        id="TelefoneEnvio"
                        maxlength="11"
                        mask="(99) 99999-9999"
                        placeholder="Numero Whatsapp ou para Msg"
                    />
                    <ErrorMessage
                        component="span"
                        name="TelefoneEnvio"
                        style={{
                            color: 'red'
                        }}
                    />
                </div>}
            </div>
        </Fieldset>
        <br />
        <br />
        <div className="p-grid p-fluid">
            <div className="p-col-12 p-md-3 p-lg-3 p-sm-3">
                <Button
                    disabled={submitButtonDisabled}
                    type="submit"
                    label='Enviar'
                    className="p-button-success"
                    onClick={handleSubmit}
                >
                </Button>
            </div>
            <div className="p-col-12 p-md-3 p-lg-3 p-sm-3">
                <Button
                    type="submit"
                    label="Fechar"
                    onClick={close}
                />
                <br />
                <br />
            </div>
        </div>
    </FormFormik>;
}
